export enum ActivityRowKind {
  Job = 'job',
  Entry = 'entry',
}
